<template>
    <div v-if="(isPriceFilter && maxRange > 0 || !isPriceFilter) && (filterList.length > 0 || isPriceFilter)" class="rhg-modal-filter" :id="id">
        <div class="rhg-modal-filter-title" @click="toggleExpand">
            <span :class="{'rhg-modal-filter-title-bold': isFilterSelected || isPriceFilterSelected}">{{ translate(title) }}</span>
        </div>
        <PriceFilter v-if="isPriceFilter && maxRange > 0" v-show="expandOrCollapse"
          :isMobile="isMobile"
          :id="id"
          :maxRange="maxRange"
          :minRange="minRange"
          :clearPrice="clearPrice"
          @updatePriceFilter="updatePriceFilter"
          @toggleClearPrice="toggleClearPrice"
          @priceFilterSelected="priceFilterSelected"/>
        <ul v-else class="rhg-modal-filter-chips" v-show="expandOrCollapse">
            <Chip v-for="filter in filterList"
              :key="filter.code"
              :id="id"
              :code="filter.code.toString()"
              :label="filter.name"
              :selectedFilters="selectedFilters"
              :isBrandFilter="isBrandFilter"
              :isMobile="isMobile"
              @filterSelected="filterSelected"
              @notSelectedFilters="notSelectedFilters"/>
        </ul>
        <div class="rhg-separator"></div>
    </div>
</template>

<script>
import PriceFilter from '@/components/filters/PriceFilter.vue'
import Chip from '@/components/common/Chip.vue'

export default {
  name: 'FilterSection',
  emits: ['filterSelected', 'unselectFilter', 'toggleExpand', 'updatePriceFilter', 'toggleClearPrice'],
  components: {
    Chip,
    PriceFilter
  },
  props: {
    title: {
      type: String,
      required: true
    },
    filterList: {
      type: Array,
      required: false,
      default: () => []
    },
    id: {
      type: String,
      required: true
    },
    minRange: {
      type: Number,
      required: false
    },
    maxRange: {
      type: Number,
      required: false
    },
    isSectionExpanded: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: false
    },
    expandAll: {
      type: Boolean,
      required: false
    },
    selectedFilters: {
      type: Array,
      required: true,
      default: () => []
    },
    clearPrice: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    isPriceFilterSelected: false
  }),
  watch: {
    clearPrice (newValue) {
      if (newValue) this.isPriceFilterSelected = false
    }
  },
  methods: {
    filterSelected (code, id) {
      this.$emit('filterSelected', code, id)
    },
    notSelectedFilters (code) {
      this.$emit('unselectFilter', code)
    },
    toggleExpand () {
      if (this.isMobile) {
        this.$emit('toggleExpand', this.id)
      }
    },
    updatePriceFilter (prices) {
      this.$emit('updatePriceFilter', prices)
    },
    toggleClearPrice () {
      this.$emit('toggleClearPrice')
    },
    priceFilterSelected (isSelected) {
      this.isPriceFilterSelected = isSelected
    }
  },
  computed: {
    expandOrCollapse () {
      if (!this.isMobile || this.expandAll) return true
      else return this.isSectionExpanded
    },
    isPriceFilter () {
      return this.id === 'price'
    },
    isBrandFilter () {
      return this.id === 'brands'
    },
    isFilterSelected () {
      return this.selectedFilters.find(filter => filter.id === this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.rhg-modal-filter {
  &-title {
    font-size: 20px;
    font-weight: normal;
    line-height: 26px;
    color:#242424;
    margin-bottom: 20px;

    &-bold {
      width: 100%;
      @media (max-width: 992px) {
        font-weight: bold;
      }
    }
  }

  &-chips {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;

    @media (min-width: 992px) {
      flex-direction: row;
    }
  }
}

.rhg-separator {
  border: 0.7px solid #D8D8D8;
  opacity: 0.25;
  background-color: #686868;
}

html[dir="rtl"]{
  .rhg-modal-filter-title {
    text-align: right;
  }
}
</style>
